<template>
  <div id="app">
    <router-view v-if="authenticated" />
    <div v-else style="display: flex; min-height: 100vh;">
      <div class="lds-spinner" style="margin: auto">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        authenticated: false
    };
  },
  created() {
    if (window.location.pathname != '/login') {
      if ( !localStorage.getItem('token') ) {
        window.location = '/login';
      } else {
        this.authenticated = true;
      }
    } else {
      if ( localStorage.getItem('token') ) {
        window.location = '/';
      } else {
        this.authenticated = true;
      }
    }
  }
}
</script>
